<template>
  <generic-configuration-card v-model="facebookPixel" :disabled="disabled" title="Pixel Facebook">
    <template #description>
      O pixel é o rastreador de anúncios do Facebook, utilizado para mensurar as suas campanhas direcionadas ao site de cadastramento. Para utiliza-lo, basta
      inserir o seu código aqui.
      <a href="https://www.facebook.com/business/help/952192354843755?id=1205376682832142" target="_blank" class="caption">
        Para saber mais sobre o pixel confira a documentação.</a
      >
    </template>
  </generic-configuration-card>
</template>

<script>
import GenericConfigurationCard from './GenericConfigurationCard.vue'

export default {
  name: 'AdsPixelFacebookConfiguration',
  components: {
    GenericConfigurationCard,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    localFacebookPixel: '',
  }),
  computed: {
    facebookPixel: {
      get() {
        return this.localFacebookPixel
      },
      set(value) {
        this.localFacebookPixel = value
        this.$emit('input', value)
      },
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.localFacebookPixel = newVal
      },
      immediate: true,
    },
  },
}
</script>
